<template>
  <div>
    <h3>{{ this.titulo }}</h3>
    <Tables
      ref="tableGrid"
      :columns="[
        $t('associates.abreviacaoNumber'),
        'CPF/CNPJ',
        'Nome',
        'Agente Relacionamento',
        'Pa',
        'E-mail',
        'Celular',
        $lang.Common.DataTable.Actions
      ]"
      :showTipFooter="false"
      v-on:Load="onLoad"
    >
      <tr
        v-for="obj in this.objList"
        v-bind:key="obj.id"
      >
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.numId.toString()"
        />
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.documento"
        />
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.nome ? obj.nome.toUpperCase() : ''"
        />
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="
            obj.agenteRelacionamento
              ? obj.agenteRelacionamento.toUpperCase()
              : ''
          "
        />
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.pa ? obj.pa.toString() : ''"
        />
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.email ? obj.email : ''"
        />
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.celular ? obj.celular.toUpperCase() : ''"
        />
        <td class="text-center">
          <div v-if="obj.inactive">
            <b-dropdown
              variant="link"
              size="sm"
              no-caret
            >
              <template slot="button-content">
                <i
                  class="fa fa-lock-open text-secundary icone-grid"
                  style="color: black"
                  :title="$lang.GroupsConfig.UnlockGroupToolTip"
                ></i>
              </template>
              <b-dropdown-header
                ><strong>Deseja reativar o contato?</strong></b-dropdown-header
              >
              <b-dropdown-item
                href="javascript:void(0);"
                v-on:click="onInactiveContact(obj)"
              >
                {{ $lang.Common.Yes }}
              </b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);">
                {{ $lang.Common.No }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div v-if="!obj.inactive">
            <b-dropdown
              variant="link"
              size="sm"
              no-caret
            >
              <template slot="button-content">
                <i
                  class="fa fa-ban text-secundary icone-grid"
                  style="color: red"
                  :title="$lang.GroupsConfig.BlockGroupToolTip"
                ></i>
              </template>
              <b-dropdown-header>
                <strong>Deseja inativar o contato?</strong>
              </b-dropdown-header>
              <b-dropdown-item
                href="javascript:void(0);"
                v-on:click="onInactiveContact(obj)"
              >
                {{ $lang.Common.Yes }}
              </b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);">
                {{ $lang.Common.No }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </td>
      </tr>
    </Tables>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ListaContatoRepository from '../../../../../../../shared/http/repositories/configurations/listacontato'
import { loading, toast } from '../../../../../../../shared/utils/UIHelper'

export default {
  name: 'ContatosGrid',
  mixins: [ActionsForm],
  data () {
    return {
      listaInteligenteId: null,
      // Força inicialização vazia para evitar dados antigos
      objList: [],
      total: 0
    }
  },
  props: {
    isInactiveGrid: {
      type: Boolean,
      Default: false
    },
    titulo: {
      type: String,
      required: true
    },
    listaInteligenteData: {
      type: Object,
      required: true
    }
  },
  mounted () {},
  watch: {
    'listaInteligenteData.id': {
      handler (newId, oldId) {
        if (newId) {
          // Tem ID - RESETA paginação e carrega dados
          if (this.$refs.tableGrid) {
            this.$refs.tableGrid.pagingIndex = 0
            this.$refs.tableGrid.currentPage = 1
            this.$refs.tableGrid.total = 0
            this.$refs.tableGrid.totalPages = 0
          }

          this.$nextTick(() => {
            this.onLoad()
          })
        } else {
          // Sem ID - LIMPA dados
          this.objList = []
          this.total = 0

          if (this.$refs.tableGrid) {
            this.$refs.tableGrid.pagingIndex = 0
            this.$refs.tableGrid.total = 0
            this.$refs.tableGrid.totalPages = 0
            this.$refs.tableGrid.currentPage = 1
          }
        }
      },
      immediate: false
    }
  },
  methods: {
    async onLoad () {
      // SIMPLES: Só carrega se tiver ID
      if (!this.listaInteligenteData || !this.listaInteligenteData.id) {
        return
      }

      this.isInactiveGrid
        ? await this.onLoadInactive()
        : await this.onLoadActive()

      if (this.objList && this.objList.length > 0) {
        this.$emit('hasObjList')
      }
    },
    recarregarDoZero () {
      // Método público para ser chamado pelo componente pai após adicionar contatos
      // Reseta paginação para página 1 e recarrega dados
      if (this.$refs.tableGrid) {
        this.$refs.tableGrid.pagingIndex = 0
        this.$refs.tableGrid.currentPage = 1
        this.$refs.tableGrid.total = 0
        this.$refs.tableGrid.totalPages = 0
      }
      this.onLoad()
    },
    gridData (response) {
      // Dados já vêm filtrados do backend
      return response
    },
    async onLoadInactive () {
      if (this.listaInteligenteData && this.listaInteligenteData.id) {
        try {
          loading.push()
          const response =
            await ListaContatoRepository.GetAllByListaInteligenteInactiveUniquePaging(
              this.listaInteligenteData.id,
              this.$refs.tableGrid.pagingLimit,
              this.$refs.tableGrid.pagingIndex
            )
          if (response.status === 200) {
            this.onResultGrid(response)
          }
        } catch (e) {
          // Fallback para endpoint antigo se os novos não estiverem disponíveis
          try {
            const fallbackResponse =
              await ListaContatoRepository.GetAllByListaInteligenteInactivePaging(
                this.listaInteligenteData.id,
                this.$refs.tableGrid.pagingLimit,
                this.$refs.tableGrid.pagingIndex
              )
            this.onResultGrid(this.gridData(fallbackResponse))
          } catch (fallbackError) {
            // Erro no fallback
          }
        } finally {
          loading.pop()
        }
      }
    },
    async onLoadActive () {
      this.$emit('triggerClasseA')
      if (this.listaInteligenteData && this.listaInteligenteData.id) {
        try {
          loading.push()

          const response =
            await ListaContatoRepository.GetAllByListaInteligenteActiveUniquePaging(
              this.listaInteligenteData.id,
              this.$refs.tableGrid.pagingLimit,
              this.$refs.tableGrid.pagingIndex
            )

          if (response.status === 200) {
            this.onResultGrid(response)
          }
        } catch (e) {
          // Fallback para endpoint antigo se os novos não estiverem disponíveis
          try {
            const fallbackResponse =
              await ListaContatoRepository.GetAllByListaInteligenteActivePaging(
                this.listaInteligenteData.id,
                this.$refs.tableGrid.pagingLimit,
                this.$refs.tableGrid.pagingIndex
              )
            this.onResultGrid(this.gridData(fallbackResponse))
          } catch (fallbackError) {
            // Erro no fallback
          }
        } finally {
          loading.pop()
        }
      }
    },
    async onInactiveContact (obj) {
      loading.push()
      obj.inactive = !obj.inactive

      ListaContatoRepository.Inactive(obj.id, obj)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)

          // Quando um contato é inativado, a API já atualiza o total
          // Então apenas recarregamos a lista para mostrar o total correto
          this.$emit('inactive')
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/grids/ContatosGrid.vue